// External Imports
import { useContext, useEffect, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { MdHelp } from "react-icons/md";

// Internal Imports
import { AuthContext } from "../../context/auth-context";
import { requestPartnerAPI } from "../../api/server";
import Modal from "./Modal";
import LoadingSpinner from "./LoadingSpinner";

/** ========================================================================
 * * IssueModal Component
 * This component renders a form to report an issue.
 * ========================================================================== */

export default function IssueModal({ open, setOpen }) {
  const { user } = useContext(AuthContext);
  const [reported, setReported] = useState(false);
  const [loading, setLoading] = useState(false);

  const submitHandler = async () => {
    try {
      setLoading(true);
      const details = document.getElementById("details")?.value;
      const url = window.location.pathname + window.location.search;
      if (!details) throw new Error("Please provide details about the issue.");

      // Send Report
      await requestPartnerAPI("report-issue", {
        details,
        url,
        email: user?.email,
      });
      setReported(true);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!open) setReported(false);
  }, [open]);

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="modal p-6 lg:max-w-[40vw]">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2 text-stone-200">
            <MdHelp className="w-5 h-5" />
            <p className="text-lg font-semibold">Report Issue</p>
          </div>

          <IoMdClose onClick={() => setOpen(false)} className="icon" />
        </div>
        {reported ? (
          <div className="grid gap-6 text-center text-stone-200">
            <p className="font-semibold">Issue Reported! ✅</p>
            <p className="text-stone-400">
              We will reach out to you as soon as possible. Thanks!
            </p>
            <div onClick={() => setOpen(false)} className="text-sm btn-secondary">Close</div>
          </div>
        ) : (
          <div className="grid gap-4 text-sm">
            <textarea
              placeholder="Please provide details about your issue..."
              className="border input border-stone-600"
              rows="4"
              id="details"
            />
            {loading ? (
              <div className="flex justify-center">
                <LoadingSpinner />
              </div>
            ) : (
              <div className="grid grid-cols-2 gap-4">
                <div className="btn-secondary" onClick={() => setOpen(false)}>
                  Cancel
                </div>
                <div className="btn-primary" onClick={submitHandler}>
                  Submit
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Modal>
  );
}
